import type { SorteDeLien } from '@nextilt/commun';

/** Un signe d'un lien, près de son trait sur la carte ou sur sa ligne de la fiche Plan (décision 11 du cadrage). */
export type SigneDuLien = 'oeil' | 'inverser' | 'croix';

/**
 * L'œil (cacher, montrer), inverser (⇄, pour « attend » et « sert à » seulement) et la croix
 * (chantier liens-entre-bulles, tickets 03 et 05). Sans croix : une condition posée, dans la
 * fiche Plan, qui garde son « Retirer » (ticket 05).
 */
export function signesDuLien(sorte: SorteDeLien, { sansCroix = false }: { sansCroix?: boolean } = {}): SigneDuLien[] {
  const signes: SigneDuLien[] = sorte === 'touche_a' ? ['oeil', 'croix'] : ['oeil', 'inverser', 'croix'];
  return sansCroix ? signes.filter((s) => s !== 'croix') : signes;
}
